import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../messages";
import toastr from "toastr";
import  municipalityUserServices from "./municipalityUserServices";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const getMunicipalityUser = filters => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: true,
        });
        let resp;
        if(filters.hasOwnProperty("tipo_busqueda")){
            resp = await municipalityUserServices.getMunicipalitiessUser(filters);
        }else if( typeof(filters)=="number" ){
            resp = await municipalityUserServices.getMunicipalityUser(filters);
        }else{
            resp = await municipalityUserServices.getMunicipalityUser();
        }
        dispatch({
            type: actions.GET_MUNICIPALITYUSER,
            payload: filters.filter !==""? resp.data : {data:"",count:0},
        });
        dispatch({
            type: actions.MUNICIPALITYUSER_FAIL,
            payload: null,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MUNICIPALITYUSER_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: false,
        });
    }
}

export const deleteMunicipalityUser = (id, index) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: true,
        });
        await municipalityUserServices.deleteMunicipalityUser(id);
        const { data, count } = getState().municipalityUser.municipalityUser;
        let _data = data.slice();
        _data.splice(index, 1);
        dispatch({
            type: actions.GET_MUNICIPALITYUSER,
            payload: {
                data: _data,
                count: count - 1
            },
        });
        dispatch({
            type: actions.MUNICIPALITYUSER_FAIL,
            payload: '',
        });
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MUNICIPALITYUSER_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: false,
        });
    }
}

export const editMunicipalityUser = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: true,
        });
        const resp = await municipalityUserServices.editMunicipalityUser(req.id, req);
        const { data, count } = getState().municipalityUser.municipalityUser;
        let _data = data.slice();
        _data[index] = resp.data;
        dispatch({
            type: actions.GET_MUNICIPALITYUSER,
            payload: {
                data: _data,
                count: count,
            },
        });
        dispatch({
            type: actions.FORM_MUNICIPALITYUSER_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });

    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MUNICIPALITYUSER_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MUNICIPALITYUSER,
            payload: false,
        });
    }
}

export const saveMunicipalityUser = (req, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.SAVE_LOADER_MUNICIPALITYUSER,
            payload: true,
        });
        const resp = await municipalityUserServices.saveMunicipalityUser(req);
        const { data, count } = getState().municipalityUser.municipalityUser;
        dispatch({
            type: actions.GET_MUNICIPALITYUSER,
            payload: {
                count: count + 1,
                data: [...data, resp.data]
            },
        });
        dispatch({
            type: actions.FORM_MUNICIPALITYUSER_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 500:
                        message = messages.errorMessage + " " + ex.response.statusText;
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = ex.response.data;
                        break;
                }
            } else {
                message =
                    ex.message === "Network Error" ? messages.networkError : ex.message;
            }
        } else {
            message =
                ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
            type: actions.FORM_MUNICIPALITYUSER_FAIL,
            payload: message,
        });
    } finally {
        dispatch({
            type: actions.SAVE_LOADER_MUNICIPALITYUSER,
            payload: false,
        });
    }
};
